<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">员工花名册</li>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        v-if="$judge_auth('7')"
        size="large"
        >导出
      </el-button>
      <el-button
        type="warning"
        :icon="Download"
        size="large"
        link
        @click="onDownLoad"
        v-if="$judge_auth('5')"
        >模板下载
      </el-button>
      <el-button
        type="success"
        :icon="Download"
        size="large"
        link
        @click="state.showImport = true"
        v-if="$judge_auth('6')"
        >批量导入
      </el-button>
      <el-button
        type="primary"
        :icon="Plus"
        size="large"
        link
        @click="
          delete state.selectId;
          state.showAdd = true;
        "
        v-if="$judge_auth('4')"
        >添加
      </el-button>
      <el-button
        type="danger"
        :icon="Delete"
        size="large"
        link
        @click="onDeletes"
        v-if="$judge_auth('6')"
      >
        批量删除
        <text v-if="state.selectIds?.filter((w) => w != -1)?.length > 0">
          ({{ state.selectIds?.filter((w) => w != -1)?.length }})
        </text>
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-radio-group v-model="state.params.status" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="1">正常</el-radio-button>
        <el-radio-button :value="0">停用</el-radio-button>
      </el-radio-group>
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="姓名、电话、身份证号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      >
        <template #suffix>
          <el-tooltip
            effect="dark"
            content="多个关键词请用英文逗号(,)隔开"
            placement="top-start"
          >
            <el-icon style="cursor: pointer"><QuestionFilled /></el-icon>
          </el-tooltip>
        </template>
      </el-input>
      <div style="display: flex">
        <el-config-provider
          :value-on-clear="null"
          :empty-values="[undefined, null]"
        >
          <el-select
            v-model="state.params.withholding_agent_type"
            class="c-withholdingagent-search-select"
            @change="
              delete state.withholding_agent_arr;
              state.showWithholdingAgent = false;
            "
          >
            <el-option label="扣缴义务人" :value="0" />
            <el-option label="供应商" :value="1" />
          </el-select>
        </el-config-provider>
        <div
          class="c-withholdingagent-search-groupbox"
          @click="state.showWithholdingAgent = true"
        >
          <li style="flex: 1; display: flex; column-gap: 5px">
            <template v-if="state.withholding_agent_arr?.length > 0">
              <div
                class="c-withholdingagent-search-tag"
                style="
                  max-width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ state.withholding_agent_arr[0]?.name }}
              </div>
              <el-popover
                v-if="state.withholding_agent_arr?.length > 1"
                placement="right"
                width="auto"
                popper-style="max-height: 90vh;overflow-y: auto;"
              >
                <template #reference>
                  <div class="c-withholdingagent-search-tag" @click.stop="">
                    {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                  </div>
                </template>
                <template #default>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      row-gap: 5px;
                      width: fit-content;
                    "
                  >
                    <ul
                      v-for="(item, index) in state.withholding_agent_arr"
                      :key="item"
                      style="
                        white-space: nowrap;
                        background-color: #f0f2f5;
                        color: var(--el-color-info);
                        border-radius: 4px;
                        font-size: 12px;
                        padding: 0 9px;
                        height: 24px;
                        line-height: 24px;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                      "
                    >
                      <li>{{ item.name }}</li>
                      <el-icon
                        @click.stop="
                          state.withholding_agent_arr.splice(index, 1)
                        "
                        color="#a2a2a2"
                        style="cursor: pointer"
                        ><CircleClose
                      /></el-icon>
                    </ul>
                  </div>
                </template>
              </el-popover>
            </template>
            <text v-else style="color: #a2a2a2">
              {{
                "点击选择" +
                (state.params.withholding_agent_type === 0
                  ? "扣缴义务人"
                  : "供应商")
              }}
            </text>
          </li>
          <el-icon
            v-if="state.withholding_agent_arr?.length > 0"
            @click.stop="delete state.withholding_agent_arr"
            color="#a2a2a2"
            ><CircleClose
          /></el-icon>
        </div>
      </div>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-checkbox-group
        v-model="state.selectIds"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column width="55" fixed @click.stop="">
            <template #header>
              <el-checkbox :value="-1" @change="onSelect($event, -1)" />
            </template>
            <template #default="{ row }">
              <el-checkbox
                :value="row.id"
                @change="onRowClick(row)"
                :disabled="row.collected_status == 2"
              />
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            prop="name"
            label="姓名"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="120"
          />
          <el-table-column prop="phone" label="手机号" width="140">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="手机号"
                @click.stop="$onCopy(row.phone)"
              >
                {{ row.phone }}
              </text>
            </template>
          </el-table-column>
          <el-table-column prop="idcard" label="证件号" width="180">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click.stop="$onCopy(row.idcard)"
              >
                {{ row.idcard }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            :formatter="
              (row) =>
                $statusFormat({
                  Text: row.status == 0 ? '停用' : '正常',
                  Color: row.status == 0 ? '#f00' : '#1e90ff',
                })
            "
            width="100"
          />
          <el-table-column prop="sex" label="性别" align="center" width="80">
            <template #default="{ row }">
              <text v-if="row.sex == '男'" style="color: #1e90ff">男</text>
              <text v-else-if="row.sex == '女'" style="color: #f00">女</text>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="customer_name"
            label="所属客户"
            :formatter="$tab_TextFormat"
            :min-width="180"
          />
          <el-table-column
            prop="withholding_agent_name"
            label="扣缴义务人"
            :min-width="220"
            :formatter="$tab_TextFormat"
          >
            <template #default="{ row }">
              <div
                v-if="row.withholding_agent_name"
                :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                :style="{
                  '--dynamic-color':
                    row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                }"
                class="withholding-badge"
              >
                {{ row.withholding_agent_name }}
              </div>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="tax_bureau_name"
            label="税局"
            :min-width="180"
            :formatter="$tab_TextFormat"
          />
          <el-table-column label="二维码" width="80" align="center">
            <template #default="{ row }">
              <el-icon style="cursor: pointer" @click.stop="onBuildQrCode(row)"
                ><View
              /></el-icon>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160"
            align="center"
            fixed="right"
            className="tabBtn"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Edit"
                @click.stop="
                  $store.commit('openMenu', {
                    path: 'EmployeeDetail',
                    title: row.name,
                    refresh: true,
                    data: {
                      id: row.id,
                    },
                  })
                "
                v-if="$judge_auth('8')"
              >
                管理
              </el-button>
              <el-button
                type="primary"
                link
                icon="View"
                @click.stop="
                  $store.commit('openMenu', {
                    path: 'EmployeeDetail',
                    title: row.name,
                    refresh: true,
                    data: {
                      id: row.id,
                    },
                  })
                "
                v-else
              >
                查看
              </el-button>
              <el-button
                type="danger"
                link
                icon="Delete"
                @click="onDelete(row.id)"
                v-if="$judge_auth('9')"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAdd"
        title="添加员工"
        @close="state.showAdd = false"
      >
        <c_EmployeeAdd
          @close="
            state.showAdd = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_EmployeeAdd>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="
          state.showWithholdingAgent &&
          state.params.withholding_agent_type === 0
        "
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="
          state.showWithholdingAgent &&
          state.params.withholding_agent_type === 1
        "
        title="选择供应商"
        @close="state.showWithholdingAgent = false"
      >
        <c_SupplierSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_SupplierSelect>
      </c_popup>
    </transition>
    <el-dialog
      v-model="state.showImport"
      title="导入员工"
      width="40%"
      align-center
      :close-on-click-modal="false"
    >
      <c_EmployeeImport
        v-if="state.showImport"
        @success="state.showImport = false"
      ></c_EmployeeImport>
    </el-dialog>
    <div
      v-show="state.showQrCode"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        z-index: 9999;
      "
      @click="state.showQrCode = false"
    >
      <div
        ref="qrcodeBox"
        style="background-color: #fff; padding: 20px"
        @click.stop=""
      >
        <div ref="qrcodeDom"></div>
        <ul
          style="
            text-align: center;
            margin-top: 5px;
            font-size: 15px;
            font-weight: 600;
          "
        >
          {{
            state.name
          }}
        </ul>
        <ul style="text-align: center; color: #a2a2a2; margin-top: 5px">
          (请使用手机扫一扫填写个人档案信息)
        </ul>
      </div>
      <ul
        style="
          width: 340px;
          text-decoration: solid;
          text-align: center;
          background-color: #fff;
          padding-bottom: 10px;
        "
      >
        <a href="#" @click="onDownLoadQrCode">下载</a>
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  employee_list,
  employee_delete,
  employee_download,
  employee_export,
} from "@/http/employee";
import { data_customer_select } from "@/http/data";
import { confirm_func } from "@/utils/qFormat";
import { ElMessage, ElMessageBox } from "element-plus";

import QRCode from "qrcodejs2-fix";
import html2canvas from "html2canvas";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}

export default {
  setup() {
    const qrcodeBox = ref(null);
    const qrcodeDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      withholding_agent_arr: [],
      selectIds: [],
    });
    onMounted(() => {
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      employee_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;

          state.selectIds = state.selectIds.filter((w) => w != -1);
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onSelect = (checked, item) => {
      if (item == -1) {
        if (checked) {
          state.selectIds = [
            ...state.selectIds,
            ...state.tableData
              .filter(
                (w) =>
                  w.collected_status != 2 && !state.selectIds.includes(w.id)
              )
              .map((m) => m.id),
          ];
        } else {
          state.selectIds = state.selectIds.filter(
            (w) => !state.tableData.map((m) => m.id).includes(w)
          );
        }
      }
    };

    const onRowClick = (item) => {
      if (state.selectIds?.includes(item.id)) {
        state.selectIds = state.selectIds.filter((w) => w != item.id);
      } else state.selectIds.push(item.id);
    };

    const onDownLoad = () => {
      employee_download()
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      employee_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    //删除
    const onDelete = (id) => {
      confirm_func(employee_delete, id, onLoad);
    };

    const onBuildQrCode = (row) => {
      state.name = row.name;

      qrcodeDom.value.innerHTML = "";
      state.showQrCode = true;
      new QRCode(qrcodeDom.value, {
        text: "https://h5.ycmtc.com/login?phone=" + row.phone,
        width: 300, // 二维码图片宽度
        height: 300, // 二维码图片高度
      });
    };

    const onDownLoadQrCode = () => {
      const element = qrcodeBox.value;

      html2canvas(element).then((canvas) => {
        // 创建一个图像元素
        let img = new Image();
        img.src = canvas.toDataURL("image/png");
        img.style.width = "500px"; // 可以设置图片的宽度
        img.style.height = "auto"; // 图片高度将按比例调整

        // 将图片添加到页面上显示
        // 例如，可以将img元素插入到DOM中的某个位置
        document.body.appendChild(img);

        // 如果需要下载图片
        let a = document.createElement("a");
        a.href = img.src;
        a.download = state.name + ".png";
        a.click();
      });
    };

    const onDeletes = () => {
      const ids = state.selectIds?.filter((w) => w != -1);
      if (ids.length > 0) {
        ElMessageBox.confirm(
          `您确定<strong style='color:#f00'>删除</strong>已选<strong style='color:#1e90ff'>${ids.length}</strong>位员工的所有数据吗？<text style='color:#f00'>删除后数据不可恢复，请谨慎操作！</text>`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          employee_delete(state.selectIds.join(",")).then((res) => {
            if (res.status == 200) {
              ElMessage.error(res.data);
              onLoad();
            }
          });
        });
      } else {
        ElMessage.warning("请选择要删除的员工！");
      }
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onLoadCustomer,
      onDownLoad,
      onExport,
      onBuildQrCode,
      qrcodeDom,
      qrcodeBox,
      onDownLoadQrCode,
      onSelect,
      onDeletes,
      onRowClick,
    };
  },
};
</script>
<style>
.input-with-select .el-input-group__prepend {
  background-color: var(--el-fill-color-blank);
}
</style>
